// Start Bear House

function bearhousecalculateshippingprice(zipcode, totalamount, totalquantity) {
  var shippingtype = 'interexpress'
  /*
  var shippingtype = "kerry";
  
  for(var i=0;i<productidlist.length;i++){
    if(!bearhouseisdryproduct(productidlist[i])){
		shippingtype = "interexpress";
		break;
	}
  }
  */
  var price = 0
  var rate = ''

  switch (zipcode) {
    case '10110':
      rate = 'BKK'
      break
    case '10600':
      rate = 'BKK'
      break
    case '10510':
      rate = 'BKK'
      break
    case '10230':
      rate = 'BKK'
      break
    case '10900':
      rate = 'BKK'
      break
    case '10150':
      rate = 'BKK'
      break
    case '10210':
      rate = 'BKK'
      break
    case '10400':
      rate = 'BKK'
      break
    case '10300':
      rate = 'BKK'
      break
    case '10170':
      rate = 'BKK'
      break
    case '10140':
      rate = 'BKK'
      break
    case '10700':
      rate = 'BKK'
      break
    case '10240':
      rate = 'BKK'
      break
    case '10220':
      rate = 'BKK'
      break
    case '10120':
      rate = 'BKK'
      break
    case '10160':
      rate = 'BKK'
      break
    case '10800':
      rate = 'BKK'
      break
    case '10260':
      rate = 'BKK'
      break
    case '10500':
      rate = 'BKK'
      break
    case '10250':
      rate = 'BKK'
      break
    case '10330':
      rate = 'BKK'
      break
    case '10100':
      rate = 'BKK'
      break
    case '10200':
      rate = 'BKK'
      break
    case '10520':
      rate = 'BKK'
      break
    case '10310':
      rate = 'BKK'
      break
    case '10530':
      rate = 'BKK'
      break
    case '11000':
      rate = 'MET'
      break
    case '11150':
      rate = 'MET'
      break
    case '11130':
      rate = 'MET'
      break
    case '11110':
      rate = 'MET'
      break
    case '11140':
      rate = 'MET'
      break
    case '11120':
      rate = 'MET'
      break
    case '12000':
      rate = 'MET'
      break
    case '12120':
      rate = 'MET'
      break
    case '12110':
      rate = 'MET'
      break
    case '12130':
      rate = 'MET'
      break
    case '12140':
      rate = 'MET'
      break
    case '12150':
      rate = 'MET'
      break
    case '12160':
      rate = 'MET'
      break
    case '12170':
      rate = 'MET'
      break
    case '10270':
      rate = 'MET'
      break
    case '10280':
      rate = 'MET'
      break
    case '10560':
      rate = 'MET'
      break
    case '10550':
      rate = 'MET'
      break
    case '10540':
      rate = 'MET'
      break
    case '10570':
      rate = 'MET'
      break
    case '10130':
      rate = 'MET'
      break
    case '10290':
      rate = 'MET'
      break
    default:
      rate = 'OTHER'
      break
  }

  if (shippingtype == 'kerry') {
    if (rate == 'BKK') {
      if (totalquantity <= 2) price = 75
      else if (totalquantity <= 4) price = 75
      else if (totalquantity <= 6) price = 90
      else price = 110
    } else {
      if (totalquantity <= 2) price = 90
      else if (totalquantity <= 4) price = 90
      else if (totalquantity <= 6) price = 100
      else price = 120
    }
  } else {
    if (rate == 'BKK' || rate == 'MET') {
      if (totalamount >= 800) price = 0
      else price = 200
    } else {
      if (totalamount >= 800) price = 150
      else price = 300
    }
  }

  return price
  /*
  return {
	  "shippingprice": price,
	  "shippingtype": shippingtype
  }
  */
}

function bearhousepackagehasbubble() {
  return [
    34073, 34072, 34071, 34067, 34065, 34064, 34063, 34267, 34266, 48959, 47418,
    48957, 48958, 73682, 73681, 73680,
    // 17/12/2020
    107757, 107756, 107755, 107754, 107753
  ]
}

function bearhousebubbletea(products) {
  return products.filter((el) => {
    return [34061, 34069].includes(el.id)
  })
}

function bearhouseisdryproduct(productid) {
  if (
    productid == '34268' ||
    productid == '39870' ||
    productid == '39871' ||
    productid == '39872' ||
    productid == '39873'
  )
    return true
  else return false
}

export {
  bearhousecalculateshippingprice,
  bearhousepackagehasbubble,
  bearhousebubbletea,
  bearhouseisdryproduct
}
// End Bear House
